import request from '@/api/request'

export default {
  async getVariationTemplate () {
    return (await request.get(`module/action/ecommerce/oneeg/variation_template`)).data
  },
  async getWarehouses () {
    return (await request.get(`module/action/ecommerce/oneeg/warehouses`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/ecommerce/oneeg/index.js